import axios from '../utils/request'

// 接口填写
export const login = query => {
  return axios({
    url: `tx4sweblogin`,
    method: 'post',
    data: query
  });
};
// 获取json
export const json = query => {
  return axios({
    url: 'https://www.fastmock.site/mock/14618bc624bf955bb72bcd934a04038a/login/login/login',
    method: 'get',
    data: query
  });
};
// 登录
export const tx4sweblogin = query => {
  return axios({
    url: 'https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/tx4sweblogin',
    method: 'post',
    data: query
  });
};
// 登录后获取权限
export const getpermission = query => {
  return axios({
    url: 'https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/getpermission',
    method: 'post',
    data: query
  });
};
// 获取轮播图/精选
export const getjingxuans = query => {
  return axios({
    url: 'https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/getjingxuans',
    method: 'post',
    data: query
  });
};
// 筛选具体内容
export const getyzarticlesbypage = query => {
  return axios({
    url: 'https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/getcomfearticlesbypage',
    method: 'post',
    data: query
  });
};
// 获取标签
export const getmasterdatatags = query => {
  return axios({
    url: 'https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/getmasterdatatags',
    method: 'post',
    data: query
  });
};
// 获取发布
export const getmasterdataauthors = query => {
  return axios({
    url: 'https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/getmasterdataauthors',
    method: 'post',
    data: query
  });
};
//标签
export const getyzarticle = (query) => {
  return axios({
    url: `https://tx4sdev.tongxianglive.cn/tx4s/getyzarticle`,
    method: 'post',
    data: query
  });
};
// 获取权限内容
export const authority = (query) =>{
  return axios({
    url:`https://www.fastmock.site/mock/14618bc624bf955bb72bcd934a04038a/login/api/userAuthority?username=${query}`,
    method: 'get',
  })
}
export const imageWeb = query => {
  return axios({
    url: 'https://www.fastmock.site/mock/14618bc624bf955bb72bcd934a04038a/login/image',
    method: 'get',
    data: query
  });
};
// 提交直播推荐/修改
export const updatecomarticle = (query) => {
  return axios({
    url: `https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/updatecomarticle`,
    method: 'post',
    data: query
  });
};
// 个人获取发布文章
export const getcomarticlesbypage = (query) => {
  return axios({
    url: `https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/getcomarticlesbypage`,
    method: 'post',
    data: query
  });
};
// 删除文章
export const aritcletoggledisplay = (query) => {
  return axios({
    url: `https://tx4qecdn.tongxianglive.com/tx3/public/index.php/index/Txsa/aritcletoggledisplay`,
    method: 'post',
    data: query
  });
};

